<template>
  <p>數值：{{ rangeBarValue }}</p>
  <CFormRange
    :id="id"
    :disabled="+info.is_help"
    :min="info.extension_info.min"
    :max="info.extension_info.max"
    :model-value="
      rangeBarValue ? String(rangeBarValue) : String(info.extension_info.min)
    "
    @change="emitContent"
  />
  <div class="d-flex justify-content-between">
    <p>{{ info.extension_info.min }}</p>
    <p>{{ info.extension_info.max }}</p>
  </div>
</template>
<script>
import { ref, watch, onMounted } from '@vue/runtime-core'
export default {
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['content'],
  setup(props, { emit }) {
    const rangeBarValue = ref(null)
    const emitContent = (e) => {
      if(e !== undefined){
        rangeBarValue.value = e?.target.value || 0
      }
      emit('content', {
        part_item_id: props.info.part_item_id,
        type: props.info.type,
        is_help: +props.info.is_help ? '1' : '0',
        help_message: props.info?.help_message ||'',
        is_finish: +rangeBarValue.value > +props.info.extension_info.min,
        value_info: +props.info.is_help === 0 ? rangeBarValue.value : null,
      })
    }
    onMounted(() => {
      emitContent()
    })
    watch(
      () => props.info.value_info,
      (newValue) => {
        emitContent({ target: { value: newValue } })
      },
      { immediate: true },
    )
    watch(
      () => props.info.is_help,
      () => {
        emitContent()
      },
      {immediate: true, deep: true}
    )
    return {
      emitContent,
      rangeBarValue,
    }
  },
}
</script>
